const removeWhiteSpace = (string) => string.replace(/\s+/g, '');

export default removeWhiteSpace;
